import { GenIcon } from '../helpers/IconBase.es.js';

const InstallmentOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.00008 3.5H18.7511C19.0272 3.5 19.2511 3.72386 19.2511 4V5.08363H8.50008V4C8.50008 3.72386 8.72393 3.5 9.00008 3.5ZM8.50008 6.58363V11.0008C8.50008 11.2769 8.72394 11.5008 9.00008 11.5008H18.7511C19.0272 11.5008 19.2511 11.2769 19.2511 11.0008V6.58363H8.50008ZM7.00008 4C7.00008 2.89543 7.89551 2 9.00008 2H18.7511C19.8556 2 20.7511 2.89543 20.7511 4V11.0008C20.7511 12.1054 19.8556 13.0008 18.7511 13.0008H9.00008C7.89551 13.0008 7.00008 12.1054 7.00008 11.0008V5.50008H6.25C5.55964 5.50008 5 6.05972 5 6.75008V19.2513C5 19.9416 5.55964 20.5013 6.25 20.5013H13.2508C13.9411 20.5013 14.5008 19.9416 14.5008 19.2513V16.2092C14.5008 15.795 14.8366 15.4592 15.2508 15.4592C15.665 15.4592 16.0008 15.795 16.0008 16.2092V19.2513C16.0008 20.77 14.7696 22.0013 13.2508 22.0013H6.25C4.73122 22.0013 3.5 20.77 3.5 19.2513V6.75008C3.5 5.23129 4.73122 4.00008 6.25 4.00008H7.00008V4ZM9.75003 9.50048C9.75003 9.08626 10.0858 8.75048 10.5 8.75048H13.5837C13.9979 8.75048 14.3337 9.08626 14.3337 9.50048C14.3337 9.91469 13.9979 10.2505 13.5837 10.2505H10.5C10.0858 10.2505 9.75003 9.91469 9.75003 9.50048ZM10.6671 17.5844C10.6671 18.0907 10.2567 18.5011 9.75036 18.5011C9.24406 18.5011 8.83363 18.0907 8.83363 17.5844C8.83363 17.0781 9.24406 16.6676 9.75036 16.6676C10.2567 16.6676 10.6671 17.0781 10.6671 17.5844Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};

export { InstallmentOutlined };
